import { StopOutlined } from "@ant-design/icons";
import { Card, Typography } from "antd";

const VpnBlockedScreen = () => {
  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#2b2b2b",
      }}
    >
      <Card justify="center" align="center">
        <StopOutlined
          style={{ fontSize: "40px", color: "red", marginBottom: "10px" }}
        />
        <Typography.Title level={2}>VPN / Proxy Not Allowed</Typography.Title>
        <p>
          VPN or proxy connections are not allowed on this website.
          <br />
          Please disable your VPN or proxy and try again.
        </p>
        {/* Info box */}
        <div
          style={{
            backgroundColor: "#f5f5f5",
            borderRadius: "8px",
            padding: "12px 16px",
          }}
        >
          <span style={{ fontSize: "13px", color: "#888" }}>
            For security reasons, actions from VPN or proxy connections are
            restricted.
          </span>
        </div>
      </Card>
    </div>
  );
};

export default VpnBlockedScreen;
